export default {
  dbs_system_title: 'Management Dashboard',
  dbs_title_business: 'Business Overview',
  dbs_title_studio: 'Studio Management',
  dbs_title_publishing: 'Publishing Management',
  dbs_center_capability: 'Capabilities & Functions',
  dbs_update_on: 'Updated on',
  dbs_period: 'Period',
  dbs_empty_text: 'Data not applicable or not available',
  dbs_empty_text_unit_sales: 'Unit sales tracking is not applicable for free-to-play games',
  dbs_total_spend: 'Total Spend',
  dbs_headcount: 'Headcount',
  dbs_actual: 'Actual',
  dbs_meeting_summary: 'Meeting Summary',
  dbs_summary: 'Summary',
  dbs_highlights: 'Highlights',
  dbs_progress_update: 'Progress Update',
  dbs_next_step: 'Next Step',
  dbs_day: 'Day', // use this for date filter
  dbs_week: 'Week', // use this for date filter
  dbs_month: 'Month',
  dbs_phase: 'Phase',
  dbs_date: 'Date',
  dbs_calendar_month: 'Calendar Month',
  dbs_in_dev: 'In Dev',
  dbs_live: 'Live',
  // common crud modal
  dbs_edit: 'Edit',
  dbs_edit_notes: 'Edit Notes',
  dbs_edit_all_studios_notes: 'Edit All Studios Notes',
  dbs_confirm: 'Confirm',
  dbs_cancel: 'Cancel',
  dbs_delete: 'Delete',
  dbs_rename: 'Rename',
  dbs_delete_project_confirm: 'Are you sure you want to delete the project?',
  // add new project modal
  dbs_add_project: 'Add Project',
  dbs_add_project_category: 'Add Project Category',
  dbs_add_category: 'Add Category',
  dbs_please_select_project: 'Please select Project',
  dbs_please_input_project_name: 'Please input project name',
  dbs_search_project: 'Search Project',
  // add new content modal
  dbs_type: 'Type',
  dbs_ai_summary: 'AI Summary',
  dbs_text: 'Text',
  dbs_data: 'Data',
  dbs_please_select_data: 'Please select dashboard data',
  dbs_preview: 'Preview',
  dbs_generate: 'Generate',
  dbs_please_enter: 'Please enter',
  dbs_footer_contact: 'If you have any questions, please contact creator Judymao@tencent.com or {contactEmail}',
  dbs_download_excel: '下载 Excel',
  dbs_download_chart: '下载图表',

};
